enum EmailTemplateType {
  VISUAL = 'visual',
  CODE = 'code',
}

export default EmailTemplateType
